import { Writing, Development, Editing, Marketing, Consultant, Translation } from "../components/images/svg/icons";

export const services = [
  { icon: Writing, title: "WRITING", desc: "WRITING_DESC" },
  { icon: Development, title: "DEVELOPMENT", desc: "DEVELOPMENT_DESC" },
  { icon: Editing, title: "PHOTO_&_VIDEO", desc: "PHOTO_&_VIDEO_DESC" },
  { icon: Marketing, title: "MARKETING", desc: "MARKETING_DESC" },
  { icon: Translation, title: "TRANSLATION", desc: "TRANSLATION_DESC" },
  { icon: Consultant, title: "CONSULTING", desc: "CONSULTING_DESC" },
];